import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon } from 'lucide-react';
import { Countdown } from './ui/Countdown';
export function UrgencySection() {
  return <section className="bg-blue-950 text-center text-white" aria-label="Limited time offer" data-id="element-271" data-mp="369pga49jt16e">
      <div className="metal-silver h-1.5 w-full" aria-hidden="true" data-id="element-272" data-mp="31j93mmdjxjl3" />
      <div className="mx-auto max-w-3xl px-4 py-12" data-id="element-273" data-mp="31hxvybgzjrop">
        <p className="inline-flex items-center gap-2 text-xs font-extrabold uppercase tracking-[.16em] text-slate-300" data-id="element-274" data-mp="3g7carz3bz1bh">
          <AlertTriangleIcon className="h-4 w-4" aria-hidden="true" data-id="element-275" data-mp="3b8946a7pcn1e" /> Launch pricing ends in
        </p>
        <Countdown className="mt-5" data-id="element-276" data-mp="3p8a3hl8bjmer" />
        <p className="mt-7 font-bold text-slate-200" data-id="element-277" data-mp="3p6h4ms3y66hb">After that the price increases and never drops again.</p>

        <div className="mx-auto mt-6 max-w-xl rounded-lg border border-slate-300/20 bg-white/5 p-4 text-sm" data-id="element-278" data-mp="1uuixqwt41mol">
          <p className="font-bold text-white" data-id="element-279" data-mp="1qtp8o03xm1u4">
            <span className="mr-2 inline-block h-2.5 w-2.5 animate-pulse rounded-full bg-slate-300" data-id="element-280" data-mp="1qv0cfzxdn9l8" />
            Remaining launch pricing spots: limited
          </p>
          <div className="mt-3 h-3 overflow-hidden rounded-full bg-white/15" data-id="element-281" data-mp="2xrzgnweyizsz">
            <motion.div initial={{
            width: 0
          }} whileInView={{
            width: '66%'
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.9,
            ease: [0.23, 1, 0.32, 1]
          }} className="metal-silver h-full rounded-full" data-id="element-282" data-mp="32s3ybprlq0ks" />
          </div>
          <p className="mt-1 text-right text-xs text-slate-300" data-id="element-283" data-mp="3gipl3pk6euny">66% of spots taken</p>
        </div>
      </div>
      <div className="metal-silver h-1.5 w-full" aria-hidden="true" data-id="element-284" data-mp="3li29ieqp49sn" />
    </section>;
}